import { arrival } from './arrival';
import { button } from './button';
import { dates } from './dates';
import { durationOptions } from './durationOptions';
import { rate } from './rate';
import { roomSingle } from './roomSingle';
import { selection } from './selection';

export default function (state, action) {
  state = selection(state, action);
  state = dates(state, action);
  state = rate(state, action);
  state = durationOptions(state, action);
  state = arrival(state, action);
  state = roomSingle(state, action);
  state = button(state, action);
  return state;
}
